
export default {
  components: {NestedMenu: () => import("./NestedMenu")},
  props: ["items"],
};
